import { render, staticRenderFns } from "./SentEmails.vue?vue&type=template&id=120a321e&scoped=true"
import script from "./SentEmails.vue?vue&type=script&lang=js"
export * from "./SentEmails.vue?vue&type=script&lang=js"
import style0 from "./SentEmails.vue?vue&type=style&index=0&id=120a321e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a321e",
  null
  
)

export default component.exports